const DEMO_ENTRY_TOAST_KEY = "demo-entry-toast";

export function markDemoEntryToast(): void {
  try {
    sessionStorage.setItem(DEMO_ENTRY_TOAST_KEY, "1");
  } catch {
    // sessionStorage unavailable — toast simply won't show
  }
}

export function consumeDemoEntryToast(): boolean {
  try {
    if (sessionStorage.getItem(DEMO_ENTRY_TOAST_KEY) !== "1") return false;
    sessionStorage.removeItem(DEMO_ENTRY_TOAST_KEY);
    return true;
  } catch {
    return false;
  }
}
